/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React from "react";
import { append_zero, two_digit_year } from "../../../assets/helper.js";
import PropTypes from "prop-types";

const CardContent = (props) => {
  return (
    <div className="SelectPayment-valid">
      Valid thru
      <div className="SelectPayment-expiry">
        <div className="SelectPayment-expiryDate">
          {append_zero(props.data.exp_month)}
        </div>
        <div className="SelectPayment-slash">/</div>
        <div className="SelectPayment-expiryYear">
          {two_digit_year(props.data.exp_year)}
        </div>
      </div>
    </div>
  );
};

CardContent.propTypes = {
  data: PropTypes.object,
};

const CardNumber = (props) => {
  return (
    <div className="SelectPayment-cardNumber">
      *&nbsp;*&nbsp;*&nbsp;*&nbsp; &nbsp; *&nbsp;*&nbsp;*&nbsp;*&nbsp; &nbsp;
      *&nbsp;*&nbsp;*&nbsp;*&nbsp; &nbsp; {props.last4}
    </div>
  );
};

CardNumber.propTypes = {
  last4: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

const AmexItem = (props) => {
  return (
    <div className="SelectPayment-amex" data-testid="selectpayment-saved-card-amex">
      <div className="SelectPayment-amexLogo"></div>
      <CardNumber last4={props.data.last4} />
      <CardContent data={props.data} />
    </div>
  );
};

AmexItem.propTypes = {
  data: PropTypes.object,
};

const VisaItem = (props) => {
  return (
    <div className="SelectPayment-visa" data-testid="selectpayment-saved-card-visa">
      <CardNumber last4={props.data.last4} />
      <div className="SelectPayment-visaLogo"></div>
      <CardContent data={props.data} />
    </div>
  );
};

VisaItem.propTypes = {
  data: PropTypes.object,
};

const MasterCardItem = (props) => {
  return (
    <div className="SelectPayment-mastercard" data-testid="selectpayment-saved-card-mastercard">
      <CardNumber last4={props.data.last4} />
      <div className="SelectPayment-mastercardLogo"></div>
      <CardContent data={props.data} />
    </div>
  );
};

MasterCardItem.propTypes = {
  data: PropTypes.object,
};

const UnionPayItem = (props) => {
  return (
    <div className="SelectPayment-unionpay" data-testid="selectpayment-saved-card-unionpay">
      <div className="SelectPayment-unionpayLogo"></div>
      <CardNumber last4={props.data.last4} />
      <CardContent data={props.data} />
    </div>
  );
};

UnionPayItem.propTypes = {
  data: PropTypes.object,
};

const SwitchCard = (props) => {
  switch (props.data.card.brand) {
    case "visa":
      return <VisaItem data={props.data.card} />;
    case "amex":
      return <AmexItem data={props.data.card} />;
    case "mastercard":
      return <MasterCardItem data={props.data.card} />;
    case "unionpay":
      return <UnionPayItem data={props.data.card} />;
    default:
      return null;
  }
};

SwitchCard.propTypes = {
  data: PropTypes.object,
};

const CardItem = (props) => {
  const onClick = (e) => {
    e.preventDefault();
    props.onCardClicked(
      props.data.id,
      props.data.card.brand,
      props.data.card.last4,
    );
  };
  return (
    <div key={props.idx} onClick={onClick}>
      <SwitchCard data={props.data} />
    </div>
  );
};

CardItem.propTypes = {
  idx: PropTypes.number,
  data: PropTypes.object,
  onCardClicked: PropTypes.func,
};

export default CardItem;
